import type { UtmTags } from "$lib/types/shared";

/**
 * Get URLSearchParams from a UtmTags object thats stores in session storage
 * @param utm UtmTags
 * @returns URLSearchParams
 */

export const getUtmSearchParams = (utm: UtmTags) => {
  utm = {
    utm_source: utm["utm_source"] || "ishavskraft.no",
    utm_medium: utm["utm_medium"] || "",
    utm_campaign: utm["utm_campaign"] || "",
    utm_term: utm["utm_term"] || "",
    utm_content: utm["utm_content"] || "",
    utm_id: utm["utm_id"] || "",
  };
  return new URLSearchParams(utm);
};
